import {createSlice, PayloadAction} from '@reduxjs/toolkit';

const isDifferentMsg = (props1, props2) => {
  const {content: content1} = props1;
  const {content: content2} = props2;
  return content1 !== content2;
};

// Slice
const MessageSlice = createSlice({
  name: 'message',
  initialState: {
    queue: [],
  },
  reducers: {
    addGlobalMsg: (state, action) => {
      const {payload: msg} = action;
      state.queue.push(msg);
    },
    updateCurrentGlobalMsg: (state, action) => {
      const {payload: msg} = action;
      state.queue[0] = msg;
    },
    removeCurrentGlobalMsg: (state) => {
      if (state.queue.length > 0) {
        // if mark as last msg, then clean msg queue
        const currentMsg = state.queue[0];
        if (currentMsg.isIgnoreRestMsg) state.queue = [];

        // get next msg
        while (state.queue.length > 0) {
          const currentMsg = state.queue.shift();
          if (state.queue.length > 0) {
            const nextMsg = state.queue[0];
            if (isDifferentMsg(currentMsg, nextMsg)) {
              break;
            }
          }
        }
      }
    },
  },
});

export const selectCurrentGlobalMsg = (state) => state.message.queue[0];

// Action creators are generated for each case reducer function
export const {addGlobalMsg, updateCurrentGlobalMsg, removeCurrentGlobalMsg} =
  MessageSlice.actions;
export default MessageSlice.reducer;
